<template>
    <section>
        <v-card class="my-3">
            <v-card-title class="text-h5">
                <span style="color: #000000; font-weight: bold">
                    Liste des categories
                </span>
            </v-card-title>
            <v-data-table :loading="isLoadingTables" loading-text="Loading..." :footer-props="{
                'items-per-page-options': [5, 10, 15, 30],
            }" class="elevation-1" item-key="id" :headers="headers" :items="categories">
                <template v-slot:[`item.image`]="{ item }">
                    <v-img v-if="item.fileUrlDBType != 'svg'" :src="item.imgUrl" width="65" height="65" />
                    <div v-if="item.fileUrlDBType === 'svg'" v-html="item.svgContent"></div>

                    <v-divider></v-divider>
                </template>

                <template v-slot:[`item.subCategoryList`]="{ item }">
                    {{item.subCategoryList.map((element) => {
                        return element.label
                    }).join(',')}}
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                    <v-icon @click="redirectToEditActualityCategory(item)">
                        {{ icons.mdiPencil }}
                    </v-icon>
                </template>
            </v-data-table>
        </v-card>

        <!-- Modal de modification de catégorie -->
        <v-dialog v-model="dialogEdit" max-width="650px" persistent>
            <v-card>
                <v-card-title class="headline font-weight-bold">
                    Modifier la catégorie
                </v-card-title>
                <v-form ref="editForm" v-model="isEditValid" lazy-validation>
                    <v-card-text class="pt-4">
                        <v-row>
                            <v-col cols="12" sm="12" md="6">
                                <v-text-field v-model="categoryToEdit.label" label="Label *" outlined dense
                                    :rules="[(v) => !!v || 'Le label est requis']" required></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="12" md="6">
                                <v-text-field v-model="categoryToEdit.labelEn" label="Label (Anglais) *" outlined dense
                                    :rules="[(v) => !!v || 'Le label anglais est requis']" required></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="12" md="6">
                                <v-textarea v-model="categoryToEdit.description" label="Description" outlined dense rows="3"></v-textarea>
                            </v-col>
                            <v-col cols="12" sm="12" md="6">
                                <v-textarea v-model="categoryToEdit.descriptionEn" label="Description (Anglais)" outlined dense rows="3"></v-textarea>
                            </v-col>
                            <v-col cols="12" class="d-flex flex-column align-center">
                                <vue-upload-multiple-image
                                    v-if="dialogEdit"
                                    v-model="images"
                                    :data-images="images"
                                    accept="image/*"
                                    name="images"
                                    drag-text="Veuillez ajouter une image Sans arrière-plan"
                                    browse-text="Browse image"
                                    primary-text="Image"
                                    mark-is-primary-text="Set default image"
                                    :min-image="1"
                                    :multiple="false"
                                    :showEdit="false"
                                    popup-text="Description default image"
                                    drop-text="Drag and drop"
                                    @upload-success="uploadImageSuccess"
                                    @before-remove="beforeRemove_BG"
                                    :idUpload="images_BGId"
                                >
                                </vue-upload-multiple-image>
                                <v-progress-linear
                                    v-if="showlowding_BG && uploadPercentage_BG < 100"
                                    style="max-width: 190px"
                                    color="primary"
                                    indeterminate
                                    rounded
                                    height="15"
                                >
                                    <strong>{{ Math.ceil(uploadPercentage_BG) }}%</strong>
                                </v-progress-linear>
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-card-actions class="px-4 pb-4">
                        <v-spacer></v-spacer>
                        <v-btn text color="error" @click="dialogEdit = false" :disabled="loadingEdit || showlowding_BG">
                            Annuler
                        </v-btn>
                        <v-btn color="info" @click="updateCategory" :loading="loadingEdit"
                            :disabled="!categoryToEdit.label || !categoryToEdit.labelEn || showlowding_BG">
                            Sauvegarder
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>

        <!-- Snackbar pour les notifications -->
        <v-snackbar :color="snackbar.color" v-model="snackbar.visible" :top="snackbar.position === 'top'">
            {{ snackbar.text }}
            <template v-slot:action="{ attrs }">
                <v-btn text v-bind="attrs" @click="snackbar.visible = false">
                    Fermer
                </v-btn>
            </template>
        </v-snackbar>
    </section>
</template>

<script>
import store from '@/store/image';
import constants from '@/utils/constants';
import { FetchAllSubCategories, getAllActualityCategory } from '@/views/qorani/services/services';
import { mdiCamera, mdiCancel, mdiDatabasePlusOutline, mdiDeleteOutline, mdiPencil } from '@mdi/js';
import axios from 'axios';
import vueUploadMultipleImage from 'vue-upload-multiple-image';

export default {
    components: {
        vueUploadMultipleImage,
    },
    data() {
        return {
            icons: {
                mdiPencil: mdiPencil,
                mdiCancel: mdiCancel,
                mdiDeleteOutline: mdiDeleteOutline,
                mdiDatabasePlusOutline: mdiDatabasePlusOutline,
                mdiCamera: mdiCamera,
            },
            addCard: false,
            isLoadingTables: true,
            categories: [],
            headers: [
                {
                    text: 'Image',
                    value: 'image',
                },
                {
                    text: 'Label',
                    value: 'label',
                },
                {
                    text: 'Label en anglais',
                    value: 'labelEn',
                },
                {
                    text: 'Description',
                    value: 'description',
                },
                {
                    text: 'Description en anglais',
                    value: 'descriptionEn',
                },
                {
                    text: 'Series',
                    value: 'subCategoryList',
                },
                {
                    text: 'Actions',
                    value: 'actions',
                },
            ],
            dialogEdit: false,
            isEditValid: false,
            loadingEdit: false,
            showlowding_BG: false,
            uploadPercentage_BG: 0,
            images_BGId: '1',
            images: [],
            categoryToEdit: {
                id: null,
                category: '',
                label: '',
                labelEn: '',
                description: '',
                descriptionEn: '',
                imgDBUrlId: 0,
                imgDBId: 0,
                fileUrlDBType: '',
                imgDBType: '',
                imgUrl: '',
                svgContent: '',
            },
            snackbar: {
                visible: false,
                text: '',
                color: 'success',
                position: 'top',
                timeout: 3000,
            },
            imagesUpload: [],
            imageUrl: '',
            imageId: '',
        };
    },
    methods: {
        redirectToEditActualityCategory(item) {
            this.editCategory(item);
        },
        editCategory(item) {
            this.categoryToEdit = {
                id: item.id,
                category: item.category || '',
                label: item.label || '',
                labelEn: item.labelEn || '',
                description: item.description || '',
                descriptionEn: item.descriptionEn || '',
                imgDBUrlId: item.imgDBUrlId || item.imgDBId || 0,
                imgDBId: item.imgDBId || item.imgDBUrlId || 0,
                fileUrlDBType: item.fileUrlDBType || item.imgDBType || '',
                imgDBType: item.imgDBType || item.fileUrlDBType || '',
                imgUrl: item.imgUrl || '',
                svgContent: item.svgContent || '',
            };

            this.images = [];
            const imgId = item.imgDBId || item.imgDBUrlId;
            if (imgId) {
                const imagePath = item.imgUrl || `${constants.QORANI}fileDB/files/${imgId}`;
                this.images.push({
                    name: "",
                    path: imagePath,
                    highlight: 1,
                    default: 1,
                });
            }

            this.dialogEdit = true;
            this.$nextTick(() => {
                if (this.$refs.editForm) {
                    this.$refs.editForm.resetValidation();
                }
            });
        },
        async uploadImageSuccess(formData, index, fileList) {
            try {
                this.showlowding_BG = true;
                this.uploadPercentage_BG = 50;
                await store.dispatch("uploadImageSuccess", {
                    formData,
                    index,
                    fileList,
                });
                const imageId = store.state.imageId;
                this.categoryToEdit.imgDBUrlId = imageId;
                this.categoryToEdit.imgDBId = imageId;
                this.uploadPercentage_BG = 100;
                console.log("Image id :", imageId);
            } catch (error) {
                console.error("Failed to upload image:", error);
            } finally {
                this.showlowding_BG = false;
            }
        },
        beforeRemove_BG(index, done, fileList) {
            this.showlowding_BG = false;
            this.uploadPercentage_BG = 0;
            const r = confirm("Supprimer l'image ?");
            if (r === true) {
                const indexInArrayImages = this.images.indexOf(fileList[index].path);
                this.categoryToEdit.imgDBUrlId = 0;
                this.categoryToEdit.imgDBId = 0;
                this.categoryToEdit.imgUrl = '';
                this.categoryToEdit.svgContent = '';
                if (index > -1) {
                    this.images.splice(indexInArrayImages, 1);
                }
                done();
            }
        },
        async updateCategory() {
            if (!this.categoryToEdit.label || !this.categoryToEdit.labelEn) {
                return;
            }
            this.loadingEdit = true;
            try {
                const payload = {
                    id: this.categoryToEdit.id,
                    category: this.categoryToEdit.category,
                    label: this.categoryToEdit.label,
                    labelEn: this.categoryToEdit.labelEn,
                    description: this.categoryToEdit.description,
                    descriptionEn: this.categoryToEdit.descriptionEn,
                    imgDBUrlId: this.categoryToEdit.imgDBUrlId || this.categoryToEdit.imgDBId || 0,
                    imgDBId: this.categoryToEdit.imgDBId || this.categoryToEdit.imgDBUrlId || 0,
                };
                const res = await axios.post(`${constants.QORANI}actualityCategory/edit/${this.categoryToEdit.id}`, payload);
                if (res.status === 200) {
                    this.dialogEdit = false;
                    await this.fetchCategories();
                    this.showSnackbar("La catégorie a été modifiée avec succès !", "success");
                } else {
                    this.showSnackbar("Erreur lors de la modification de la catégorie", "error");
                }
            } catch (error) {
                console.error("Erreur lors de la modification de la catégorie:", error);
                this.showSnackbar(error?.response?.data?.message || "Erreur lors de la modification de la catégorie", "error");
            } finally {
                this.loadingEdit = false;
            }
        },
        async fetchCategories() {
            this.isLoadingTables = true;
            this.categories = await getAllActualityCategory();
            this.categories.forEach(item => {
                this.loadImage(item);
            });
            this.isLoadingTables = false;
        },
        async loadImage(item) {
            const isSvg = item.imgDBType === 'svg' || item.fileUrlDBType === 'svg';
            const imgId = item.imgDBId || item.imgDBUrlId;
            if (isSvg && imgId) {
                try {
                    const response = await fetch(
                        `${constants.QORANI}fileDB/files/${imgId}`
                    );
                    if (!response.ok)
                        throw new Error("Échec du chargement de l'image SVG");

                    let svgContent = await response.text();

                    // Ajoute width et height directement dans le SVG
                    svgContent = svgContent
                        .replace(/(<svg[^>]*)\swidth="[^"]*"/i, "$1")
                        .replace(/(<svg[^>]*)\sheight="[^"]*"/i, "$1")
                        .replace(/(<svg[^>]*)>/i, '$1 width="65" height="65">');

                    item.svgContent = svgContent;
                } catch (error) {
                    console.error("Erreur lors du chargement de l'image :", error);
                }
            } else if (imgId) {
                item.imgUrl = `${constants.QORANI}fileDB/files/${imgId}`;
            }
        },
        showSnackbar(text, color = "success") {
            this.snackbar.text = text;
            this.snackbar.color = color;
            this.snackbar.visible = true;
        },
    },
    async created() {
        await this.fetchCategories();
    },
};
</script>

<style></style>